export const SCHEMA_FULL = 'all';
export const SCHEMA_COMMENT = 'comment';
